import _ from '@lodash';
import { useEffect, useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import useRouter from '@fuse/hooks/useRouter';
import axios from "@fuse/utils/axios";
import { AgGridReact } from 'ag-grid-react';
import '../../../../styles/ag-custom.css';
import { openFormViewerDialog, setFromData } from '../store/formViewDialogReducer';
import useToast from '@fuse/hooks/useToast'
import { useDispatch, useSelector } from 'react-redux'
import { setFilterList, setRowGroupModel } from '../store/filterParamsReducer';
import 'ag-grid-enterprise';
import 'styles/ag-grid-header-style.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import GeneralModal from '@fuse/components/Modal/GeneralModal';
import { setQuickFilter } from '../../reports/store/reportViewDialogReducer';
import AgGridFilterGroupView from '@fuse/components/AgGridFilterGroupView';
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';
import ActivityAgGridListingSameAsSam from '@fuse/components/ActivitieLogs/activitiesAgGridListingSameAsSam';

const useStyles = makeStyles({
	layoutRoot: {},
	head: {
		position: "sticky",
		top: 0
	},
	root: {
		// minWidth: 275,
	},
	title: {
		fontSize: 14,
	},
	pos: {
		marginBottom: 12,
	},
	cardGen: {
		width: '20%',
		height:"100%"
	},
	searchbar: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-end',
		margin:'5px 5px 5px 0',
		height:'28px'
	},
	activeTab: {
		background:"rgba(107, 44, 87, 0.04);",
		borderRadius:"0",
	},
	buttonSquare : {
		borderRadius:'5px'
	},
	btn:{
		background:"#30C90A",
		width:"120px",
		borderRadius:"17px",
		color:"#fff"
	},
	icon:{
		fontSize:"18px",
		color:"#61656F",
		display:"inline-block"
	}
});

function ListView(props) {
	const table_name = "LOCATION_TYPES";
    const classes = useStyles();
	const router = useRouter()
	const dispatch = useDispatch();
	const toast = useToast(dispatch)
	const [gridApi, setGridApi] = useState(null);
	const gridRef = useRef();
	const [ windowHeight, setWindowHeight ] = useState(window.innerHeight-330);
	const query_data = useSelector((state) => state.reportApp.reportViewDialogReducer.quick_filter);
	const skipHeader = ["id","description"]
	const [locationTypeDetails, setLocationTypeDetails] = useState(null)
	const [rowGroupPanelShow, setRowGroupPanelShow] = useState('never');
	const [tabValue, setTabValue] = useState(0)
	const [groupByArr, setGroupByArr] = useState([])
	const [logs,setLogs] = useState([]);
	const [filterApplied, setFilterApplied] = useState(false);
	const [loadingActivityLog,setLoadingActivityLog] = useState(false);
	const tab_value = useSelector((state) => state.reportApp.reportViewDialogReducer.tab_value);

	const handelEdit = (data) =>{
		dispatch(setFromData(data))
		dispatch(openFormViewerDialog())
	}

	function handelDelete(){
		if(!locationTypeDetails) return
		axios.delete(`/location-type/delete/${locationTypeDetails.id}`).then((res)=>{
			toast.success(res.data.message)
			props.getLocationTypes()
		}).catch((err)=>{
			console.log(err)
			toast.error(err.response.data.message);
		})
	}

	function formatString(str){
        if(!str) return ''
		if(str === 'description_as_plain_text') return 'Description'
        return str.split('_').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ')
    }
	
	const onGridReady = (params) => {
		gridRef.current = params;
		if(router.query.report_name == undefined) {
			loadInitialState (params)
			dispatch(setFilterList({}));
			dispatch(setRowGroupModel([]));
		}else{
			getReport(params);
		}
	}

	function getReport(event){
		const { report_name } = router.query;
		const table_name = "location type";
		axios.get(`/reports/view-report?table_name=${table_name}&report_name=${report_name}`)
		.then(results=>{
			const model = JSON.parse(results.data.data.filter);
			event.api.setFilterModel(model);
			const row_model = JSON.parse(results.data.data.row_model);
			event.api?.getColumnState(row_model);
		})
		.catch(err=>{
			console.log(err);
		})
	}

	function onFilterChanged(event){ 
		const rows = event.api.getFilterModel();
		// stop rerender to show no overlay text
		dispatch(setFilterList(rows));
		saveView("N/A", rows, gridRef.current.filterModelArr)
		// validation for no-overlay 
		const total_rows = event.api.getDisplayedRowCount();
		if(total_rows === 0 ){
			event.api.showNoRowsOverlay();
		}else{
			event.api.hideOverlay();
		}
	}

	function loadInitialState(params) {
		axios
		.get(`/user-view/show-view-order?table_name=${table_name}`)
		.then((results) => {
			const { data } = results.data;
			if (data !== null) {
				const order = JSON.parse(data.order);
				const filter = JSON.parse(data.filter);
				gridRef.current = {...gridRef.current,filterModelArr:filter}
				params?.api?.applyColumnState({ state: order });
				params?.api.setFilterModel(filter);
				if(Object.keys(filter)?.length){
					setFilterApplied(true)
				}
			} else {
				gridRef.current = params
			}
		})
		.catch((err) => {
			console.log(err);
		});
  	}
	function onSortChanged(params){
		if (router.query.report_name == undefined) {
			const rows = params.api?.getColumnState();
			dispatch(setRowGroupModel(rows));
			saveView(rows);
		}
  	}

	function saveView(rows, filter,filterModelArr=null) {
		let payload = {}
		if(rows == 'N/A'){
		payload = {
			filter:  JSON.stringify(filterModelArr ?? filter),
			table_name
		}
		}else{
		payload = {
			order:  JSON.stringify(rows),
			table_name
		}
		}
		axios.post('/user-view/save-view-order',payload)
		.then(()=>{
		console.log('view updated')
		})
		.catch(err=>{
		console.log(err);
		})
	}

	const onColumnMoved = (params) =>{
		if(router.query.report_name == undefined) {
			const rows = params.api?.getColumnState();
			saveView(rows);
			dispatch(setRowGroupModel(rows))
		}
	}

	const onColumnPinned = (params) =>{
		if(router.query.report_name == undefined) {
			const rows = params.api?.getColumnState();
			saveView(rows);
			dispatch(setRowGroupModel(rows))
		}
	}

	function onColumnVisible(params){
		const rows = params.api?.getColumnState();
		dispatch(setRowGroupModel(rows))
		const total_no_of_columns = rows.length;
		let total_hidden_columns = 0;
		rows.forEach(row=>{
			const { hide } = row;
			if(hide) {
				++total_hidden_columns;
			}
		});
		if( total_hidden_columns < total_no_of_columns){
			if(router.query.report_name == undefined) {
				saveView(rows);
			}
		}
	}

	function onColumnRowGroupChanged(event){
		if (router.query.report_name == undefined) {
			const rows = event.api?.getColumnState();
			const first_row = rows[1];
			if (first_row.colId !== "ag-Grid-AutoColumn") {
				dispatch(setRowGroupModel(rows));
				saveView(rows);
			} else {
				dispatch(setRowGroupModel(rows));
			}
		}
		if(event.columns.length == 0) {
			setGroupByArr([])
		}else{
			setGroupByArr(event.columns)
		}
	}

	const generateHeaderLabel = (header) => {
		if(header === 'description_as_plain_text') return 'Description'
		return header.split('_').map(word => {
			return word.charAt(0).toUpperCase() + word.substring(1)
		}).join(' ')
	}

	const handleConfirm = (data) => {
		setLocationTypeDetails(data)
	}

	const handleClose = () => {
		setLocationTypeDetails(null)
	}

	useEffect(()=>{
		gridRef.current.api?.setQuickFilter(query_data);
	},[query_data])

	useEffect(()=>{
		return () => {
			dispatch(setQuickFilter(null))
		}
	},[])

	const frameworkComponents = {
		customFilter: CustomFilter,
	};

	const handleChildClick = (value) => {
		setTabValue(value)
  };

	// Logs
	function formatLogs(data){
		let { length } = data
		return data.map((item)=>{
				const obj =  {
						id:item.id,
						action_id: `act${length}`,
						
						action_date_and_time: item.created_at,
						location_type_name: item?.location_type?.name || item.type_name,
						name: item.user_name,
						action: item.action_name,
						description: item.comment,
						previous_value: item.previous_data,
						current_value: item.current_data,
						field_name: item.action_field_name,
						user_role: item.user_role_name,
						company_name: item?.user_company?.company_name,
				}
				length --;
				return obj
		})
	}

	function getLogs(){
		setLoadingActivityLog(true)
		axios.get("/location-type/activities").then((res) => {
			setLogs(formatLogs(res.data.data.activities));
		}).catch((err) => {
			console.log(err)
		}).finally(() => {
			setLoadingActivityLog(false)
		});
	}

	useEffect(()=>{
		if(tabValue == 1){
			getLogs()
			setFilterApplied(false)
		}
	},[tabValue])

	useEffect(()=>{
    setTabValue(tab_value)
  }, [tab_value]);

	return (
		<>	
		{ (tabValue == 0) &&	
		<AgGridFilterGroupView tableRef={gridRef} setRowGroupPanelShow={setRowGroupPanelShow}
				 groupByArrFromList ={ groupByArr }
				tableName="location_type" logs={logs} displayTableName="Location Types"
				 onClick={handleChildClick}
			/>}

			{(tabValue == 1) && (<ActivityAgGridListingSameAsSam module="location_type" logs={logs} displayTableName="Location Types"
				addPermission = {props.createSLAggrementPermission}
				loadingActivityLog={loadingActivityLog}
				/>)}
			{(tabValue == 0) && <div 
				className="ag-theme-alpine" 
				style={{
					width: "100%",
					height:windowHeight+105,
					fontSize:'11px'
				}}
			>
				<AgGridReact
					ref={gridRef}
					theme='legacy'
					suppressRowClickSelection
					onGridReady = { onGridReady }
					animateRows
					rowData={props.locationTypes}
					rowHeight={30}
					headerHeight={44}
					onRowClicked={() => {
					}}
					
					// no rows overlay 
					overlayNoRowsTemplate="<span>No Result Found</span>"

					// Row Grouping conditions
					showOpenedGroup
					suppressDragLeaveHidesColumns
					suppressMakeColumnVisibleAfterUnGroup
					rowGroupPanelShow={ rowGroupPanelShow }

					onColumnMoved = { onColumnMoved }
					onColumnPinned = { onColumnPinned }
					onColumnVisible = { onColumnVisible }
					onSortChanged={onSortChanged}
					groupHeaderHeight ={1}
					components={frameworkComponents}
					floatingFiltersHeight = {40}
					onFilterChanged = { onFilterChanged }	
					
					// on column group changed
					onColumnRowGroupChanged = { onColumnRowGroupChanged }

					pagination
					defaultColDef={{
						enableRowGroup:true,
						resizable: true
					}}
					columnDefs={[
						...Object.keys(props.locationTypes[0])
							.filter((header) => !skipHeader.includes(header))
							.map((header) => {
								return {
									field: header,
									sortable: true,
									flex: 1,
									minWidth: 200,
									filter: "agTextColumnFilter",
									headerName: generateHeaderLabel(header),
									headerComponent: (props) => CustomFilter(props, header, gridRef),
								};
							})
					]}
				/>
			</div>}

			<GeneralModal
				open={locationTypeDetails}
				title="Delete Location Type"
				text={<h4>Are you sure to delete this location type named as <b>{locationTypeDetails?.location_type}</b>?</h4>}
				handleClose={handleClose}
				handleConfirm={handelDelete}
			/>
		</>
	);
}

export default ListView